import React from 'react'
import { Skeleton } from '@mui/material'
import { useHistory } from 'react-router'

import OverflowText from '@SonarCX/components/atoms/OverflowText'
import Button from '@SonarCX/components/atoms/Button2'

import { Routes } from '@SonarCX/Routes'
import useInfiniteFetch from '@SonarCX/hooks/useInfiniteFetch'
import { useTaskList } from '@SonarCX/providers/TaskListProvider'
import { useTaskPageState } from '@SonarCX/providers/TaskPageStateProvider'
import useStyles from './styles'

type SubtasksProps = {
  task: LocalTask
  containerID: string
}

const Subtasks: React.FC<SubtasksProps> = ({ task, containerID }) => {
  const history = useHistory()

  const { setIDs } = useTaskList()
  const { setLastViewedColumn, setLastViewedCard } = useTaskPageState()

  const classes = useStyles()

  const { flatData, isLoading, canLoadMore, isEmpty, loadMore } =
    useInfiniteFetch(() => {
      return `subtasks:${task.id}:`
    }, 5)

  const handleClick = React.useCallback(
    (id: string) => {
      setLastViewedColumn(containerID)
      setLastViewedCard(task.id)

      // Update task arrows
      const ids = flatData.map((task: APITask) => task.id)
      setIDs(ids, id)

      // Go to task
      history.push(`${Routes.TASKS}/${id}`)
    },
    [
      setLastViewedColumn,
      setLastViewedCard,
      task.id,
      containerID,
      setIDs,
      flatData,
      history
    ]
  )

  return (
    <div className={classes.root}>
      {!isEmpty && (
        <div className={classes.tasks}>
          {flatData.map((task: APITask) => (
            <OverflowText
              key={task.id}
              onClick={e => {
                e.stopPropagation()
                handleClick(task.id)
              }}
              className={classes.subtask}
            >
              {task.title}
            </OverflowText>
          ))}
        </div>
      )}

      {isEmpty && <div>No subtasks.</div>}

      {isLoading && <Skeleton variant='rectangular' width='100%' height={20} />}

      {canLoadMore && (
        <Button
          onClick={e => {
            e.stopPropagation()
            loadMore()
          }}
          className={classes.button}
        >
          Load More
        </Button>
      )}
    </div>
  )
}

export default Subtasks
